/**
 * ChatWidgetWrapper
 *
 * A smart wrapper that:
 * 1. Checks if the AI chat feature is enabled (headerDetails.chatEnabled)
 * 2. Resolves the current lessonKey from context
 * 3. Conditionally renders the ChatWidget only when a lesson is selected
 *
 * Mount this component in LessonsLayout to provide
 * the chat widget on lesson pages.
 */

import { useLessonSelector, useUserSelector } from "@context/hooks";

import { getIsChatEnabled } from "@/utils/featureFlags";

import ChatWidget from "./ChatWidget";

const ChatWidgetWrapper = () => {
  const { selectedLesson } = useLessonSelector();
  const { headerDetails } = useUserSelector();

  const isChatEnabled = getIsChatEnabled(headerDetails?.chatEnabled);
  const lessonKey = selectedLesson?.key ?? null;

  // Don't render if feature is disabled or no lesson context available
  if (!isChatEnabled || !lessonKey) {
    return null;
  }

  return <ChatWidget lessonKey={lessonKey} />;
};

export default ChatWidgetWrapper;
